export default __webpack_public_path__ + "static/media/accessdenied.ac5f33f1.svg";